import { helper } from '@ember/component/helper';

export function and(params /*, hash*/) {
  let passes = true;

  for (const param of params) {
    if (!param) {
      passes = false;
      break;
    }
  }

  return passes;
}

export default helper(and);
